import { PickDomain } from '../../../../shared/utilities/types/PickDomain';
import { PointOfInterest } from '../types/PointOfInterest';

export function getOnlinePointsOfInterestWithDescription<
    P extends PickDomain<
        PointOfInterest,
        'isOnline',
        { description: PointOfInterest['description'] | null }
    >,
>(pointOfInterests: Array<P>) {
    return pointOfInterests.filter(
        (
            item,
        ): item is P & {
            isOnline: true;
            description: string;
        } => {
            return item.isOnline && item.description !== null;
        },
    );
}
